import { useState } from 'react'
import DocumentDropDown from './DocumentDropDown'
import SvgChevronArrow from '../assets/images/components/SvgChevronArrow'
import {
  ATTACHMENT_FIELD_OPTIONS,
  AttachmentsListForDocumentProps,
} from '../utils'

const AttachmentsList: React.FC<AttachmentsListForDocumentProps> = ({
  attachments,
  onOptionClick,
  maximumVisibleAttachmentCount = 2,
}) => {
  const [expanded, setExpanded] = useState(false)

  const visibleAttachments = expanded
    ? attachments
    : attachments.slice(0, maximumVisibleAttachmentCount)

  const remainingCount = attachments.length - maximumVisibleAttachmentCount

  return (
    <div className="flex justify-between items-start">
      <div className="flex flex-wrap items-center gap-4">
        {visibleAttachments.map((item) => (
          <DocumentDropDown
            key={item.attachment_name}
            attachment={item}
            options={[
              {
                label: ATTACHMENT_FIELD_OPTIONS.DOWNLOAD,
                value: ATTACHMENT_FIELD_OPTIONS.PREVIEW_LOWERCASE,
              },
              {
                label: ATTACHMENT_FIELD_OPTIONS.PREVIEW,
                value: ATTACHMENT_FIELD_OPTIONS.DOWNLOAD_LOWERCASE,
              },
            ]}
            onOptionClick={onOptionClick}
          />
        ))}

        {/* Show "+X" tile if there are hidden attachments */}
        {!expanded && remainingCount > 0 && (
          <div
            className="flex rounded-lg h-[2.125rem] w-[2.125rem] bg-secondary-25 text-gray-700 text-xs font-medium cursor-pointer hover:bg-gray-200 justify-center items-center"
            onClick={() => setExpanded(true)}
            role="button"
          >
            +{remainingCount}
          </div>
        )}
      </div>
      <div>
        {attachments.length > maximumVisibleAttachmentCount && (
          <div
            className="flex items-center justify-center w-6 h-6 rounded-full hover:bg-gray-300"
            onClick={() => setExpanded(!expanded)}
            role="button"
          >
            <SvgChevronArrow
              className={`transform transition-transform duration-200 ${
                expanded ? 'rotate-180' : ''
              }`}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default AttachmentsList
